import { useLayoutEffect, useState } from "react";

// Whether a line-clamped element actually cut its text. Measured, not guessed
// from the length: whether the lines hold the text depends on the column's
// width, so it is measured again on every resize and whenever `deps` change.
export const useIsTruncated = (ref, deps) => {
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const measure = () => {
      const element = ref.current;
      setTruncated(element.scrollHeight > element.clientHeight);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return truncated;
};
